<template>
  <modal
    v-slot="{ data }"
    name="no-selected-location-modal"
    modal-style="compact"
    :display-header-title="false"
  >
    <no-selected-location :data="data" />
  </modal>
</template>


<script>
  import NoSelectedLocation from './no-selected-location/index.vue';


  export default {
    name: 'NoSelectedLocationModal',

    components: {
      NoSelectedLocation
    }
  };
</script>
